/**
 * Created by dri on 4/16/18.
 */
import * as Backbone from "backbone";
import {BaseView} from "../_BaseViews";


export interface BaseGenericModalOptions extends Backbone.ViewOptions<Backbone.Model> {
    func: any;
    name: string;
    text?: string;
    buttonText?: string;
    titleText?: string;
}

export class BaseGenericModal extends BaseView {
    public genericIdSelector: string = '';

    constructor(options: BaseGenericModalOptions) {
        super(<any> options);
    }

    show() {
        (<any> this.$('#'+this.genericIdSelector)).modal('show');
    }

    hide() {
        (<any> this.$('#'+this.genericIdSelector)).modal('hide');
    }

    setFormSubmitted() {
        this.$('.modal-footer button').addClass('hidden');
        this.$('.modal-footer .modal-form-spinner').removeClass('hidden');
    }

    setFormError() {
        this.$('.modal-footer button').removeClass('hidden');
        this.$('.modal-footer .modal-form-spinner').addClass('hidden');
        this.$('.modal-footer .modal-form-spinner').addClass('hidden');
    }

    handleModalHidden() {
        this.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/_BaseGenericModal.ts